import { render, staticRenderFns } from "./assessmentVersionTable.vue?vue&type=template&id=044e4b5f&scoped=true&"
import script from "./assessmentVersionTable.vue?vue&type=script&lang=js&"
export * from "./assessmentVersionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e4b5f",
  null
  
)

export default component.exports